var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-open-chat-instant"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.body)?_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }